import styled from 'styled-components';

export const PremiumLabelSmall = styled.label`
  color: var(--grey500);
  font-feature-settings: 'clig' off, 'liga' off;
  /* 10px / regular - label */
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 8px; /* 80% */
  cursor: text;
`;
